export const CREATE_TICKET = "CREATE_TICKET";
export const SEARCH_USER = "SEARCH_USER";
export const USER_ROLE_DROPDOWN = "USER_ROLE_DROPDOWN"
export const SAVE_EXTERNAL_USER = "SAVE_EXTERNAL_USER"
export const EXTERNAL_USER_LIST = "EXTERNAL_USER_LIST"